import React, { Component } from 'react'
import './table.less'
interface iProps {
    children:React.ReactNode
}
export default class TableAction extends Component<iProps> {
    render() {
        return (
            <div className="action">
                {this.props.children}
            </div>
        )
    }
}
